import { GOOGLE_REVIEWS_MODULE } from './constants';

/**
 * @param {string} clinicId
 * @param {{ consentId?: string, origin?: string }} [options]
 */
export function buildReviewPageUrl(clinicId, options = {}) {
  const id = String(clinicId || '').trim();
  if (!id) return '';
  const origin =
    options.origin || (typeof window !== 'undefined' ? window.location.origin : 'https://smileconsent.co.uk');
  const base = `${origin.replace(/\/$/, '')}${GOOGLE_REVIEWS_MODULE.publicPathPrefix}/${encodeURIComponent(id)}`;
  const consentId = String(options.consentId || '').trim();
  if (!consentId) return base;
  return `${base}?consent=${encodeURIComponent(consentId)}`;
}
